import { PictureOutlined, UploadOutlined } from '@ant-design/icons';
import { Segmented, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import type { StaticIconGroup } from '@/services/static-icons';
import { resolveImageFieldMode, type ImageFieldMode } from './imageFieldUtils';
import IconUploader from './IconUploader';
import StaticIconSelector from './StaticIconSelector';

interface SelectableImageFieldProps {
  value?: string;
  onChange?: (url: string) => void;
  staticGroup: StaticIconGroup;
  disabled?: boolean;
  uploadPlaceholder?: string;
  staticPlaceholder?: string;
}

const SelectableImageField: React.FC<SelectableImageFieldProps> = ({
  value,
  onChange,
  staticGroup,
  disabled = false,
  uploadPlaceholder = '上传图片',
  staticPlaceholder = '选择静态图标',
}) => {
  const [mode, setMode] = useState<ImageFieldMode>(resolveImageFieldMode(value));

  useEffect(() => {
    setMode(resolveImageFieldMode(value));
  }, [value]);

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Segmented<ImageFieldMode>
        value={mode}
        onChange={(next) => setMode(next)}
        disabled={disabled}
        options={[
          {
            label: (
              <Space size={6}>
                <UploadOutlined />
                <span>上传图片</span>
              </Space>
            ),
            value: 'upload',
          },
          {
            label: (
              <Space size={6}>
                <PictureOutlined />
                <span>静态图标</span>
              </Space>
            ),
            value: 'static',
          },
        ]}
      />
      {mode === 'upload' ? (
        <IconUploader
          value={value}
          onChange={onChange}
          placeholder={uploadPlaceholder}
          disabled={disabled}
        />
      ) : (
        <StaticIconSelector
          group={staticGroup}
          value={value}
          onChange={onChange}
          placeholder={staticPlaceholder}
          disabled={disabled}
        />
      )}
    </Space>
  );
};

export default SelectableImageField;
